import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetch: (config: AxiosRequestConfig) =>
        api.get(`/print/printers`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/print/printers/${url.id}`, config),
};

export default requests;
